import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/logo.png'


const _hoisted_1 = {
  id: "contact",
  class: "py-10 bg-black text-white"
}
const _hoisted_2 = { class: "container mx-auto px-6" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 gap-16" }
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = { class: "flex text-xl font-semibold mb-4" }
const _hoisted_6 = { class: "flex text-xl font-semibold mb-4" }
const _hoisted_7 = { class: "flex space-x-4" }
const _hoisted_8 = { class: "relative group" }
const _hoisted_9 = { class: "absolute bottom-full mb-4 opacity-0 invisible group-hover:opacity-100 group-hover:visible qrcode-transition transform group-hover:translate-y-0 translate-y-2 z-10" }
const _hoisted_10 = { class: "relative bg-white p-3 rounded-lg shadow-xl border border-gray-200 w-48 max-h-screen" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "font-bebas tracking-wider flex items-center justify-self-center" }
const _hoisted_13 = { class: "text-3xl md:text-5xl font-bold" }
const _hoisted_14 = {
  id: "contact",
  class: "py-10 bg-black text-white"
}
const _hoisted_15 = { class: "container mx-auto px-6" }
const _hoisted_16 = { class: "grid grid-cols-1 md:grid-cols-4 gap-16" }
const _hoisted_17 = { class: "mb-6" }
const _hoisted_18 = { class: "mb-6" }
const _hoisted_19 = { class: "mb-6" }

import { ref, onMounted } from "vue";

// 联系表单

export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const contactForm = ref({
  name: "",
  email: "",
  message: "",
});
const submitForm = () => {
  alert("感谢您的留言！我们会尽快回复您。");
  contactForm.value = {
    name: "",
    email: "",
    message: "",
  };
};
onMounted(() => {});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t("company.contact_information")), 1),
              _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"flex items-center mb-3\" data-v-7f2c975a><i class=\"fas fa-map-marker-alt w-6\" data-v-7f2c975a></i><span class=\"ml-3\" data-v-7f2c975a>待完善</span></div><div class=\"flex items-center mb-3\" data-v-7f2c975a><i class=\"fas fa-phone w-6\" data-v-7f2c975a></i><span class=\"ml-3\" data-v-7f2c975a>待完善</span></div><div class=\"flex items-center mb-3\" data-v-7f2c975a><i class=\"fas fa-envelope w-6\" data-v-7f2c975a></i><span class=\"ml-3\" data-v-7f2c975a>bikes@bjqteam.com</span></div>", 3))
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("company.contact_follow_us")), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[2] || (_cache[2] = _createElementVNode("button", { class: "w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all duration-300 cursor-pointer" }, [
                    _createElementVNode("i", { class: "fab fa-weixin text-xl" })
                  ], -1)),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "absolute bottom-full left-1/2 -translate-x-1/2 opacity-0 invisible group-hover:opacity-100 group-hover:visible z-20" }, [
                    _createElementVNode("i", { class: "fa-solid fa-caret-down" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        src: require('@/assets/ncoreimg/wxQRcode.jpg'),
                        alt: "公众号二维码",
                        class: "w-full h-auto rounded"
                      }, null, 8, _hoisted_11),
                      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-xs text-center text-gray-600 mt-2" }, " 扫码关注公众号 ", -1))
                    ])
                  ])
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("a", {
                  href: "#",
                  class: "w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all duration-300 cursor-pointer"
                }, [
                  _createElementVNode("i", { class: "fab fa-weibo text-xl" })
                ], -1)),
                _cache[5] || (_cache[5] = _createElementVNode("a", {
                  href: "#",
                  class: "w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all duration-300 cursor-pointer"
                }, [
                  _createElementVNode("i", { class: "fab fa-tiktok text-xl" })
                ], -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[6] || (_cache[6] = _createElementVNode("img", {
              src: _imports_0,
              alt: "Logo",
              class: "mr-1",
              style: {
                width: 'auto',
                height: '80px',
                transform: 'translateY(-3px)',
              }
            }, null, -1)),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("company.name")), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_17, [
              _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "flex text-xl font-semibold mb-4" }, "关于我们", -1)),
              _createVNode(_component_router_link, {
                to: "/cultureAndValues",
                class: "flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("header.culture_and_values")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: { path: '/cultureAndValues', hash: '#milestone' },
                class: "flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("header.milestone")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: { path: '/cultureAndValues', hash: '#leadershipTeam' },
                class: "flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("header.leadership_team")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/ourBusiness",
                class: "flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("header.our_business")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_18, [
              _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "flex text-xl font-semibold mb-4" }, "服务资源", -1)),
              _createVNode(_component_router_link, {
                to: "/manualsGuide",
                class: "flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createElementVNode("span", { class: "" }, "手册和指南", -1)
                ])),
                _: 1,
                __: [8]
              }),
              _createVNode(_component_router_link, {
                to: "/faq",
                class: "flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode(" 常见问题 ")
                ])),
                _: 1,
                __: [9]
              }),
              _createVNode(_component_router_link, {
                to: "/securityCheck",
                class: "flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode(" 防伪查询 ")
                ])),
                _: 1,
                __: [10]
              })
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_19, [
              _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "flex text-xl font-semibold mb-4" }, "法律信息", -1)),
              _createVNode(_component_router_link, {
                to: "/privacyPolicy",
                class: "flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode(" 隐私政策 ")
                ])),
                _: 1,
                __: [12]
              }),
              _createVNode(_component_router_link, {
                to: "/disclaimer",
                class: "flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode(" 法律声明 ")
                ])),
                _: 1,
                __: [13]
              })
            ])
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "mb-6" }, [
              _createElementVNode("h3", { class: "flex text-xl font-semibold mb-4" }, "联系我们"),
              _createElementVNode("div", { class: "flex items-center mb-3" }, [
                _createElementVNode("span", { class: "" }, "联系我们")
              ])
            ])
          ], -1))
        ])
      ])
    ]),
    _cache[16] || (_cache[16] = _createStaticVNode("<footer class=\"bg-black text-white py-8\" data-v-7f2c975a><div class=\"container mx-auto px-6\" data-v-7f2c975a><div class=\"flex flex-col justify-between items-center\" data-v-7f2c975a><div class=\"mb-4 md:mb-0\" data-v-7f2c975a><p class=\"text-sm text-gray-400\" data-v-7f2c975a> ICP备案/许可证号： <a href=\"https://beian.miit.gov.cn\" class=\"no-underline hover:underline hover:text-blue-800\" data-v-7f2c975a>浙ICP备2025176188号-1</a></p><p data-v-7f2c975a> Copyright © 2025 The North Cycling Team. All Rights Reserved. 北境骑团 bjqteam.com 版权所有 </p></div></div></div></footer>", 1))
  ]))
}
}

})